export default "__VITE_ASSET__61141d91__"